module.exports = __webpack_public_path__ + "static/pattern@2x-9789853fa4f81d76fd3f714b5c9da362.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pricing/pattern@2x.png
// module id = 2675
// module chunks = 168707334958949